import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  root: {
    height: '40px',
    borderRadius: '4px',
    fontSize: '0.875rem',
    padding: '0 10px',
    textTransform: 'unset',
    marginRight: '4px',
  },
  primary: {
    background: (props) => theme.palette.btnPrimary[props.app || 'main'].bg,
    color: (props) => theme.palette.btnPrimary[props.app || 'main'].fg,
    '&:hover': {
      backgroundColor: (props) =>
        theme.palette.btnPrimary[props.app || 'main'].bg,
      color: (props) => theme.palette.btnPrimary[props.app || 'main'].fg,
      opacity: '0.9',
    },
    boxShadow: '0px 11px 12px -10px rgba(4, 105, 221, 0.7)',
  },
  secondary: {
    backgroundColor: (props) =>
      theme.palette.btnSecondary[props.app || 'main'].bg,
    color: (props) => theme.palette.btnSecondary[props.app || 'main'].fg,
    border: 'solid 1px #BAC0D0',
    '&:hover': {
      backgroundColor: (props) =>
        theme.palette.btnSecondary[props.app || 'main'].bg,
      color: (props) => theme.palette.btnSecondary[props.app || 'main'].fg,
      border: (props) =>
        `solid 1px ${theme.palette.btnSecondary[props.app || 'main'].fg}`,
      opacity: '0.9',
    },
  },
  delete: {
    backgroundColor: theme.palette.btnDelete.bg,
    color: theme.palette.btnDelete.fg,
    '&:hover': {
      backgroundColor: theme.palette.btnDelete.bg,
      color: theme.palette.btnDelete.fg,
      opacity: '0.9',
    },
  },
  disabled: {
    backgroundColor: theme.palette.btnDisabled.bg,
    color: theme.palette.btnDisabled.fg,
    '&:hover': {
      backgroundColor: theme.palette.btnDisabled.bg,
      color: theme.palette.btnDisabled.fg,
      opacity: '0.9',
    },
  },
}));
